import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueApexCharts from 'vue3-apexcharts'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { installErrorReporting } from './services/errorReporting'
import './assets/styles/index.css'

const app = createApp(App)

// Before Sentry.init: Sentry wraps an existing Vue errorHandler rather than
// replacing it, so both see component errors. Sends to Discord via
// reportClientError - see src/services/errorReporting.ts.
installErrorReporting(app, router)

Sentry.init({
  app,
  dsn: 'https://cf134303951a585cf0bf184fe02d59f6@o4511820566626304.ingest.de.sentry.io/4511820574228560',
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  },
})

// Toast plugin configuration
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__bounce',
  maxToasts: 3,
  newestOnTop: true,
  toastClassName: 'turtledove-toast',
  bodyClassName: ['turtledove-toast-body'],
})

app.use(createPinia())
app.use(router)
app.use(VueApexCharts)

app.mount('#app')
